const rowHeight = 48;
export {
  rowHeight
};
//# sourceMappingURL=types.js.map
